export default __webpack_public_path__ + "KaTeX_Script-Regular.a1c15978d325f10dcb49f0f8bd7055dd.woff2";